import "./JobStatus.scss";
import React, { useMemo } from "react";
import { ReactComponent as CompletedIcon } from "../../assets/icons/tick.svg";
import { ReactComponent as InProgressIcon } from "../../assets/icons/job-status-icon.svg";
import { ReactComponent as CancelledIcon } from "../../assets/icons/cancel.svg";

interface JobStatusProps {
  jobStatus: string;
}

const JobStatus: React.FC<JobStatusProps> = React.memo(({ jobStatus }) => {
  const { label, backgroundColor, textColor, icon } = useMemo(() => {
    const statusStyles: Record<
      string,
      {
        label: string;
        backgroundColor: string;
        textColor: string;
        icon?: JSX.Element;
      }
    > = {
      INITIATED: {
        label: "Initiated",
        backgroundColor: "#F5F7F7",
        textColor: "#838285",
        icon: <InProgressIcon />,
      },
      ASSIGNED: {
        label: "Assigned",
        // backgroundColor: "#19b5fe33",
        backgroundColor: "#F5F7F7",
        textColor: "#027CB5",
        icon: <InProgressIcon />,
      },
      STARTED: {
        label: "In Progress",
        backgroundColor: "#F5F7F7",
        // backgroundColor: "#D6A501",
        textColor: "#D6A501",
        icon: <InProgressIcon />,
      },
      IN_PROGRESS: {
        label: "In Progress",
        backgroundColor: "#F5F7F7",
        // backgroundColor: "#D6A501",
        textColor: "#D6A501",
        icon: <InProgressIcon />,
      },
      COMPLETED: {
        label: "Completed",
        backgroundColor: "#F5F7F7",
        // backgroundColor: "#01BA65",
        textColor: "#01BA65",
        // icon: <CompletedIcon />,
        icon: <InProgressIcon />,
      },
      CANCELLED: {
        label: "Cancelled",
        backgroundColor: "#F5F7F7",
        // backgroundColor: "transparent",
        textColor: "#b9b9b9",
        // icon: <CancelledIcon />,
        icon: <InProgressIcon />,
      },
      DELETED: {
        label: "Deleted",
        backgroundColor: "#F5F7F7",
        textColor: "#E30034",
        // backgroundColor: "#E30034",
        // backgroundColor: "transparent",
        // textColor: "#F5F7F7",
        icon: <CancelledIcon />,
        // icon: <InProgressIcon />,
      },
      PENDING: {
        label: "Pending",
        backgroundColor: "#F5F7F7",
        // backgroundColor: "#D6A501",
        textColor: "#D6A501",
        icon: <InProgressIcon />,
      },
      EDITED: {
        label: "Edited",
        backgroundColor: "#F5F7F7",
        // backgroundColor: "#D6A501",
        textColor: "#6802b5",
        icon: <InProgressIcon />,
      },
    };

    // console.log(jobStatus);
    // console.log(statusStyles[jobStatus]);

    return (
      statusStyles[jobStatus] || {
        label: "Unknown",
        backgroundColor: "#F5F7F7",
        textColor: "#000000",
      }
    );
  }, [jobStatus]);

  return (
    <span
      className="job-status"
      style={{
        // backgroundColor: backgroundColor,
        // backgroundColor: "transparent",
        // opacity: 0.8,
        color: textColor,
        // padding: "4px 12px",
        // borderRadius: "50px",
        fontWeight: "600",
        fontSize: "14px",
        // display: "flex",
        // justifyContent: "center",
        // alignItems: "center",
        // gap: "6px",
        // border: `1px solid ${textColor}`,
        // minWidth: "150px",
      }}
    >
      {label}
      {/* {icon && <span className="status-icon">{icon}</span>} */}
    </span>
  );
});

export default JobStatus;
